import WhoWeAreMainContent from "./WhoWeAreContent";

export default WhoWeAreMainContent;